import { CanActivateFn, Router } from '@angular/router';
import { ConfigState, selectUserRoles } from 'src/store/reducers/config.reducer';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { AuthService } from 'src/services/auth.service';
import { NotificationService } from 'src/services/notification.service';
import { RoleType } from 'src/enums/role-type.enum';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { setUserRoles } from 'src/store/actions/config.action';

export const writeAccessGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const notificationService = inject(NotificationService);
    const router = inject(Router);
    const store = inject<Store<{ config: ConfigState }>>(Store);

    return store.select(selectUserRoles).pipe(
        take(1),
        switchMap((roles) => {
            if (roles.includes(RoleType.Write)) return of(true);

            return authService.getUserStatus().pipe(
                map((status) => {
                    const freshRoles = status.internalClaims ?? [];
                    store.dispatch(setUserRoles({ roles: freshRoles }));

                    if (freshRoles.includes(RoleType.Write)) return true;

                    return router.createUrlTree(['/home']);
                }),
                catchError((error: unknown) => {
                    notificationService.handleError('Failed to verify write access', error);

                    return of(router.createUrlTree(['/home']));
                })
            );
        })
    );
};
